import { Container } from "react-bootstrap";
import styled from "styled-components";
import { darkenHexColor } from "../helpers/ColorsHelpers";



// Simple hex color darken utility

const FVActionButtons = {

    Container: styled.div`
        display: flex;
        gap: 8px;
    `,

    Button: styled.button<{background?: string, color?: string}>`
        background: ${props => props.background || 'transparent'};
        border: 1px solid #ccc;
        border-radius: 4px;
        padding: 8px 12px;
        color: ${props => props.color || 'white'};
        cursor: pointer;

        &:hover {
            background: ${props =>
                props.background
                    ? darkenHexColor(props.background, 0.1)
                    : '#f0f0f0'};
        }
    `

}

export default FVActionButtons;